import { Link } from 'react-router';
import { companyPath } from '../data/relations.js';
import { StatusPill } from './ui.jsx';

// An "other" participant (ANDEN_DELTAGER, for example a foreign company) is in neither
// cvr nor cvrperson. The participant page still works for it: it lists the companies
// through the deltagerRelation index, and says that cvrperson has no record.
const KINDS = {
  person: { title: 'Person', mark: '●', path: '/Person/' },
  company: { title: 'Company', mark: '■', path: '/Company/' },
  other: { title: 'Other participant, not in the CVR register', mark: '◆', path: '/Person/' },
};

function Row({ item }) {
  const kind = KINDS[item.kind] ?? KINDS.company;
  const label = item.name || item.enhedsNummer;
  return (
    <li className="rel-row">
      <div className="who">
        <span className="kind" title={kind.title} aria-hidden="true">{kind.mark}</span>
        {kind.path
          ? <Link to={item.kind === 'company' ? companyPath(item) : `${kind.path}${item.enhedsNummer}`}>{label}</Link>
          : <span title={kind.title}>{label}</span>}
      </div>
      <span className="roles">{item.roles.join(' · ')}</span>
      {item.status && <StatusPill status={item.status} />}
      {item.share !== null && <span className="pill good plain">{String(item.share).replace('.', ',')} %</span>}
      {item.wasOwner && <span className="pill plain">Former owner</span>}
    </li>
  );
}

/** The active relations in a list; the inactive ones behind a disclosure. */
export default function RelationList({ active, inactive, empty }) {
  if (active.length === 0 && inactive.length === 0) return <p className="muted">{empty}</p>;
  return (
    <>
      {active.length > 0 && (
        <div className="rel-group">
          <h3>Active · {active.length}</h3>
          <ul className="rel-list">{active.map((item) => <Row key={`${item.enhedsNummer}`} item={item} />)}</ul>
        </div>
      )}
      {inactive.length > 0 && (
        <details className="rel-group" open={active.length === 0}>
          <summary>Former · {inactive.length}</summary>
          <ul className="rel-list">{inactive.map((item) => <Row key={`${item.enhedsNummer}`} item={item} />)}</ul>
        </details>
      )}
    </>
  );
}
